import { FC } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { hideAlertDialog } from '../../redux/actions/Dialog'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { RootState } from '../../redux/store'

const Alert: FC = () => {
    const dispatch = useAppDispatch()
    const { Show, Header, Body, OkButtonText, OkButtonAction } = useAppSelector(
        (state: RootState) => state.DialogReducer.AlertDialog
    )

    const okAction = () => {
        OkButtonAction && OkButtonAction()
        dispatch(hideAlertDialog())
    }

    return (
        <Modal show={Show} size='lg' aria-labelledby='contained-modal-title-vcenter' centered>
            <Modal.Header
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Modal.Title>{Header}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {Body && <div dangerouslySetInnerHTML={{ __html: Body }}></div>}
            </Modal.Body>
            <Modal.Footer
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Button variant='success' onClick={okAction}>
                    {OkButtonText}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export { Alert }
